import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown, Menu, Icon, Button, Spin } from 'antd';
import { AppState } from 'store';
import { fetchFileAsync, fetchHtmlPrintAsync } from './SearchExport.actions';
import { PrintButton, IconTypeNames } from 'common';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';

const ButtonGroup = Button.Group;

const SearchExport: React.FC = () => {
  const dispatch = useDispatch();
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const { searchExport }: any = useSelector((state: AppState) => ({
    searchExport: state.searchExport,
  }));

  const executeExport = (e: any) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(fetchFileAsync(e.key, response.accessToken));
      });
    }
  };

  const executePrint = () => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(fetchHtmlPrintAsync(response.accessToken));
      });
    }
  };

  return (
    <Spin spinning={searchExport.loading} tip="Exporting...">
      <ButtonGroup>
        <PrintButton
          size={'default'}
          icon={IconTypeNames.PRINTER}
          onClick={executePrint}
        />
        <Dropdown
          overlay={
            <Menu onClick={executeExport}>
              <Menu.Item key="doc">
                <Icon type="file-word" />
                MS Word
              </Menu.Item>
              <Menu.Item key="pdf">
                <Icon type="file-pdf" />
                PDF
              </Menu.Item>
              <Menu.Item key="html">
                <Icon type="html5" />
                HTML
              </Menu.Item>
              <Menu.Item key="txt">
                <Icon type="file-text" />
                Text
              </Menu.Item>
            </Menu>
          }
        >
          <Button type="primary" shape="round" icon="download">
            Export&nbsp;
            <Icon type="down" />
          </Button>
        </Dropdown>
      </ButtonGroup>
    </Spin>
  );
};

export default React.memo(SearchExport);
